<template>
  <div class="product-quality-mgmt-page purchase-mgmt-page">
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>产品管理</el-breadcrumb-item>
        <el-breadcrumb-item>产品质检管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div ref="header" class="page-header">
      <div class="filter-card header-box">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">材料Id</span>
            <el-input
              v-model="queryParams.filterMaterialId"
              placeholder="请输入"
              size="small"
              clearable
              class="filter-input-material-id"
              @keyup.enter.native="onQueryClick"
            ></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">材料</span>
            <el-select
              v-model="queryParams.filterMaterialSelectId"
              placeholder="全部"
              size="small"
              filterable
              clearable
              class="filter-select-wide"
            >
              <el-option
                v-for="item in materialOptions"
                :key="item.materialId"
                :label="getMaterialOptionLabel(item)"
                :value="item.materialId"
              ></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="toolbar-tip">共 {{ totalRecords }} 条</span>
          </div>
        </div>
        <div class="filter-toolbar">
          <div class="filter-actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="onQueryClick">查询</el-button>
            <el-button size="small" icon="el-icon-refresh-left" @click="onResetClick">重置</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-panel" ref="tablePanel">
      <div class="table-container">
        <el-table
          :data="tableData"
          border
          stripe
          size="mini"
          :height="screenHeight"
          class="mgmt-table"
          header-cell-class-name="table-header-cell"
          v-loading="loading"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column label="序号" width="60" align="center">
            <template slot-scope="scope">
              {{ beginIndex + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="材料名称" min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tooltip :content="'材料Id：' + scope.row.materialId" placement="top">
                <span>{{ scope.row.materialName || "-" }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="采购颜色" min-width="320">
            <template slot-scope="scope">
              <div v-if="getColorList(scope.row).length" class="color-thumb-row">
                <div v-for="item in getColorList(scope.row)" :key="item.color" class="color-thumb-item">
                  <el-image
                    v-if="item.imageUrl"
                    class="color-thumb-image"
                    :src="item.imageUrl"
                    :preview-src-list="getPreviewList(scope.row)"
                    fit="cover"
                  ></el-image>
                  <div v-else class="color-thumb-placeholder">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                  <div class="color-thumb-name" :title="getColorDisplayName(item)">
                    {{ getColorDisplayName(item) }}
                  </div>
                </div>
              </div>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column label="质检标准" min-width="280">
            <template slot-scope="scope">
              <div v-if="getQualityStandards(scope.row).length" class="qc-standard-list">
                <div v-for="(item, idx) in getQualityStandards(scope.row)" :key="'qc-' + idx" class="qc-standard-item">
                  <div class="qc-standard-content" :title="item.content">{{ idx + 1 }}. {{ item.content || "（未填写说明）" }}</div>
                  <div v-if="item.imageUrls && item.imageUrls.length" class="qc-standard-thumbs">
                    <el-image
                      v-for="(url, uIdx) in item.imageUrls"
                      :key="url + '-' + uIdx"
                      class="qc-standard-thumb"
                      :src="url"
                      :preview-src-list="item.imageUrls"
                      fit="cover"
                    ></el-image>
                  </div>
                </div>
              </div>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="qualityRemark" label="质检备注" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.qualityRemark">{{ scope.row.qualityRemark }}</span>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="320" fixed="right" align="center" class-name="action-col">
            <template slot-scope="scope">
              <div class="action-cell">
                <el-button type="text" size="small" @click="openUploadDialog(scope.row)">上传/替换图片</el-button>
                <el-button type="text" size="small" @click="openQualityDialog(scope.row)">编辑质检标准</el-button>
                <el-button type="text" size="small" @click="openQualityRemarkDialog(scope.row)">编辑质检备注</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :total="totalRecords"
          @current-change="onPageChange"
        />
      </div>
    </div>

    <el-dialog
      :title="qualityRemarkDialogTitle"
      :visible.sync="qualityRemarkDialogVisible"
      width="520px"
      custom-class="material-quality-remark-dialog"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-input
        v-model="editQualityRemark"
        type="textarea"
        :rows="5"
        maxlength="500"
        show-word-limit
        placeholder="请输入质检备注"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="qualityRemarkDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="savingQualityRemark" @click="saveQualityRemark">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="uploadDialogTitle"
      :visible.sync="uploadDialogVisible"
      width="720px"
      custom-class="material-quality-upload-dialog"
      :close-on-click-modal="false"
      append-to-body
      @opened="onColorUploadDialogOpened"
      @closed="onColorUploadDialogClosed"
    >
      <div
        ref="colorPastePanel"
        class="upload-panel"
        tabindex="0"
        v-loading="uploading"
      >
        <div v-if="editColorList.length" class="upload-toolbar">
          <span class="upload-toolbar-tip">点击某一颜色行后可 Ctrl+V 粘贴截图（每色仅 1 张，粘贴即替换）</span>
        </div>
        <div v-if="!editColorList.length" class="upload-empty">该材料暂无采购颜色，请先在材料管理中配置</div>
        <div v-else class="upload-color-list">
          <div
            v-for="(item, index) in editColorList"
            :key="item.color + '-' + index"
            class="upload-color-row"
            :class="{ 'is-active': activeColorIndex === index }"
            @mousedown.stop="setActiveColorIndex(index)"
          >
            <div class="upload-color-meta">
              <div class="upload-color-title-wrap">
                <div class="upload-color-title">{{ getColorDisplayName(item) }}</div>
                <el-tag v-if="activeColorIndex === index" size="mini" type="primary" effect="plain">当前粘贴目标</el-tag>
              </div>
              <div class="upload-color-sub">亚马逊色：{{ item.color || "-" }}</div>
            </div>
            <div class="upload-color-media">
              <div v-if="item.imageUrl" class="upload-preview-wrap">
                <el-image class="upload-preview-image" :src="item.imageUrl" :preview-src-list="[item.imageUrl]" fit="cover"></el-image>
                <i class="el-icon-error upload-preview-clear" @click="clearColorImage(index)"></i>
              </div>
              <el-upload
                class="upload-add"
                action="#"
                name="file"
                accept="image/*"
                :show-file-list="false"
                :http-request="options => customUpload(options, index)"
                :before-upload="beforeImageUpload"
                :disabled="uploading"
              >
                <div class="upload-trigger">
                  <i class="el-icon-plus"></i>
                  <span>{{ item.imageUrl ? "替换" : "上传" }}</span>
                </div>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="upload-tip">每个采购颜色仅保留 1 张图；支持 JPG、PNG、GIF、WEBP、BMP；弹窗内可粘贴截图；确定后写入材料</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="saving" :disabled="!editColorList.length" @click="saveColorImages">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="qualityDialogTitle"
      :visible.sync="qualityDialogVisible"
      width="860px"
      custom-class="material-quality-standard-dialog"
      :close-on-click-modal="false"
      append-to-body
      @opened="onQualityDialogOpened"
      @closed="onQualityDialogClosed"
    >
      <div
        ref="qualityPastePanel"
        class="qc-edit-panel"
        tabindex="0"
        v-loading="uploading"
      >
        <div class="qc-edit-toolbar">
          <div class="qc-edit-toolbar-left">
            <span class="qc-edit-count">共 {{ editQualityStandards.length }} 条</span>
            <span class="qc-edit-toolbar-tip">点击标准块后可 Ctrl+V 粘贴截图</span>
          </div>
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="addQualityStandard">添加标准</el-button>
        </div>

        <div v-if="!editQualityStandards.length" class="qc-edit-empty">
          <i class="el-icon-document"></i>
          <p>暂无质检标准</p>
          <el-button type="primary" size="mini" plain icon="el-icon-plus" @click="addQualityStandard">添加第一条</el-button>
        </div>

        <div v-else class="qc-edit-list">
          <div
            v-for="(item, index) in editQualityStandards"
            :key="'edit-qc-' + index"
            class="qc-edit-card"
            :class="{ 'is-active': activeQualityIndex === index }"
            @mousedown.stop="setActiveQualityIndex(index)"
          >
            <div class="qc-edit-card-header">
              <div class="qc-edit-card-title-wrap">
                <span class="qc-edit-index">{{ index + 1 }}</span>
                <span class="qc-edit-card-title">质检标准</span>
                <el-tag v-if="activeQualityIndex === index" size="mini" type="primary" effect="plain">当前粘贴目标</el-tag>
              </div>
              <el-button
                type="text"
                size="mini"
                icon="el-icon-delete"
                class="qc-edit-remove"
                @click="removeQualityStandard(index)"
              >删除</el-button>
            </div>

            <div class="qc-edit-field">
              <div class="qc-edit-label">说明 <em>最多 200 字</em></div>
              <el-input
                type="textarea"
                :rows="3"
                maxlength="200"
                show-word-limit
                placeholder="请输入质检标准说明"
                v-model="item.content"
                @focus="setActiveQualityIndex(index)"
              ></el-input>
            </div>

            <div class="qc-edit-field">
              <div class="qc-edit-label">
                附图
                <em>{{ (item.imageUrls && item.imageUrls.length) || 0 }} 张</em>
              </div>
              <div class="qc-edit-images">
                <div v-for="(url, imgIndex) in item.imageUrls" :key="url + '-' + imgIndex" class="upload-preview-wrap">
                  <el-image class="upload-preview-image" :src="url" :preview-src-list="item.imageUrls" fit="cover"></el-image>
                  <button type="button" class="upload-preview-clear" title="删除图片" @click="removeQualityImage(index, imgIndex)">
                    <i class="el-icon-close"></i>
                  </button>
                </div>
                <el-upload
                  class="upload-add"
                  action="#"
                  name="file"
                  accept="image/*"
                  :show-file-list="false"
                  :http-request="options => customQualityUpload(options, index)"
                  :before-upload="beforeImageUpload"
                  :disabled="uploading"
                >
                  <div class="upload-trigger">
                    <i class="el-icon-plus"></i>
                    <span>上传</span>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>
        </div>

        <div class="qc-edit-footer-tip">
          <i class="el-icon-info"></i>
          <span>支持 JPG / PNG / GIF / WEBP / BMP；每条标准可多图；弹窗内选中标准后粘贴截图即可添加</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="qualityDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="savingQuality" @click="saveQualityStandards">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules, ossModules } from "@r";
import { colors } from "../../utils/constant.js";

export default {
  name: "ProductQualityMgmt",
  data() {
    return {
      colors,
      loading: false,
      uploading: false,
      saving: false,
      savingQuality: false,
      savingQualityRemark: false,
      screenHeight: 400,
      beginIndex: 0,
      pageSize: 50,
      currentPage: 1,
      totalRecords: 0,
      tableData: [],
      materialOptions: [],
      queryParams: {
        filterMaterialId: "",
        filterMaterialSelectId: "",
      },
      uploadDialogVisible: false,
      qualityRemarkDialogVisible: false,
      qualityDialogVisible: false,
      currentRow: null,
      editQualityRemark: "",
      editColorList: [],
      editQualityStandards: [],
      activeQualityIndex: 0,
      activeColorIndex: 0,
    };
  },
  computed: {
    uploadDialogTitle() {
      const name = (this.currentRow && this.currentRow.materialName) || "";
      return name ? `上传/替换图片 - ${name}` : "上传/替换图片";
    },
    qualityDialogTitle() {
      const name = (this.currentRow && this.currentRow.materialName) || "";
      return name ? `编辑质检标准 - ${name}` : "编辑质检标准";
    },
    qualityRemarkDialogTitle() {
      const name = (this.currentRow && this.currentRow.materialName) || "";
      return name ? `编辑质检备注 - ${name}` : "编辑质检备注";
    },
  },
  mounted() {
    this.$eventBus.$on("resize", this.calculateHeight);
    this.fetchMaterialOptions();
    this.fetchList();
    this.$nextTick(() => {
      this.calculateHeight();
    });
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    getMaterialOptionLabel(item) {
      if (!item) {
        return "";
      }
      return item.materialName ? `${item.materialName}（${item.materialId}）` : String(item.materialId);
    },
    getColorList(row) {
      if (!row || !row.purcharseColorList) {
        return [];
      }
      return Array.isArray(row.purcharseColorList) ? row.purcharseColorList : [];
    },
    getColorDisplayName(item) {
      if (!item) {
        return "-";
      }
      if (item.purcharseColorName) {
        return item.purcharseColorName;
      }
      const color = this.colors.find(c => c.key === item.color);
      return (color && color.name) || item.color || "-";
    },
    getPreviewList(row) {
      return this.getColorList(row)
        .map(item => item.imageUrl)
        .filter(Boolean);
    },
    getQualityStandards(row) {
      if (!row || !row.qualityStandards) {
        return [];
      }
      if (Array.isArray(row.qualityStandards)) {
        return row.qualityStandards;
      }
      try {
        const parsed = JSON.parse(row.qualityStandards);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    },
    buildListParams() {
      const params = {
        beginIndex: this.beginIndex,
        pageSize: this.pageSize,
      };
      if (this.queryParams.filterMaterialSelectId) {
        params.materialId = this.queryParams.filterMaterialSelectId;
      } else if (String(this.queryParams.filterMaterialId || "").trim()) {
        params.materialId = String(this.queryParams.filterMaterialId).trim();
      }
      return params;
    },
    fetchMaterialOptions() {
      requestModules.fetchMaterials({ beginIndex: 0, pageSize: 10000 }).then(res => {
        if (res.result === 1) {
          this.materialOptions = (res.ldata || []).slice().sort((a, b) => b.materialId - a.materialId);
        }
      });
    },
    fetchList() {
      this.loading = true;
      requestModules
        .fetchMaterials(this.buildListParams())
        .then(res => {
          if (res.result !== 1) {
            this.tableData = [];
            this.totalRecords = 0;
            this.$message.error(res.msg || res.message || "查询失败");
            return;
          }
          this.tableData = res.ldata || [];
          this.totalRecords = res.total != null ? res.total : this.tableData.length;
        })
        .finally(() => {
          this.loading = false;
          this.$nextTick(() => {
            this.calculateHeight();
          });
        });
    },
    onQueryClick() {
      this.currentPage = 1;
      this.beginIndex = 0;
      this.fetchList();
    },
    onResetClick() {
      this.queryParams = {
        filterMaterialId: "",
        filterMaterialSelectId: "",
      };
      this.onQueryClick();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.beginIndex = (page - 1) * this.pageSize;
      this.fetchList();
    },
    calculateHeight() {
      const panel = this.$refs.tablePanel;
      if (!panel) {
        return;
      }
      const pagination = panel.querySelector(".pagination-box");
      const style = window.getComputedStyle(panel);
      const paddingTop = parseFloat(style.paddingTop) || 0;
      const paddingBottom = parseFloat(style.paddingBottom) || 0;
      const paginationHeight = pagination ? pagination.offsetHeight : 0;
      const availableHeight = panel.clientHeight - paddingTop - paddingBottom - paginationHeight - 12;
      this.screenHeight = availableHeight > 200 ? availableHeight : 200;
    },
    openUploadDialog(row) {
      this.currentRow = row;
      this.editColorList = this.getColorList(row).map(item => ({
        color: item.color,
        purcharseColorName: item.purcharseColorName || "",
        imageUrl: item.imageUrl || "",
      }));
      this.activeColorIndex = 0;
      this.uploadDialogVisible = true;
    },
    setActiveColorIndex(index) {
      this.activeColorIndex = index;
    },
    onColorUploadDialogOpened() {
      document.addEventListener("paste", this.handleColorPaste);
      this.$nextTick(() => {
        if (this.$refs.colorPastePanel) {
          this.$refs.colorPastePanel.focus();
        }
      });
    },
    onColorUploadDialogClosed() {
      document.removeEventListener("paste", this.handleColorPaste);
      this.uploading = false;
      this.activeColorIndex = 0;
    },
    handleColorPaste(event) {
      if (!this.uploadDialogVisible || this.uploading || this.qualityDialogVisible) {
        return;
      }
      const items = event.clipboardData && event.clipboardData.items;
      if (!items || !items.length) {
        return;
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === "file" && item.type.indexOf("image/") === 0) {
          event.preventDefault();
          const file = item.getAsFile();
          if (file) {
            this.uploadColorImageFile(file, this.resolveActiveColorIndex());
          }
          return;
        }
      }
    },
    resolveActiveColorIndex() {
      if (!this.editColorList.length) {
        return -1;
      }
      if (this.activeColorIndex >= 0 && this.activeColorIndex < this.editColorList.length) {
        return this.activeColorIndex;
      }
      return 0;
    },
    uploadColorImageFile(file, colorIndex) {
      if (colorIndex < 0) {
        this.$message.error("暂无采购颜色可粘贴");
        return;
      }
      if (!this.isImageFile(file)) {
        this.$message.error("请粘贴图片文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("bizModule", "materialQuality");
      this.uploading = true;
      ossModules
        .upload(formData)
        .then(res => {
          if (res && res.objData && res.objData.fileUrl) {
            this.$set(this.editColorList[colorIndex], "imageUrl", res.objData.fileUrl);
            return;
          }
          this.$message.error((res && res.message) || "上传失败");
        })
        .catch(err => {
          this.$message.error((err && err.message) || "上传失败");
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    isImageFile(file) {
      if (!file) {
        return false;
      }
      if (file.type && file.type.indexOf("image/") === 0) {
        return true;
      }
      const name = (file.name || "").toLowerCase();
      return /\.(jpg|jpeg|png|gif|webp|bmp)$/.test(name);
    },
    beforeImageUpload(file) {
      if (!this.isImageFile(file)) {
        this.$message.error("请上传图片文件");
        return false;
      }
      return true;
    },
    customUpload(options, index) {
      this.setActiveColorIndex(index);
      const file = options && options.file;
      if (!this.isImageFile(file)) {
        this.$message.error("请上传图片文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("bizModule", "materialQuality");
      this.uploading = true;
      ossModules
        .upload(formData)
        .then(res => {
          if (res && res.objData && res.objData.fileUrl) {
            this.$set(this.editColorList[index], "imageUrl", res.objData.fileUrl);
            if (options && typeof options.onSuccess === "function") {
              options.onSuccess(res);
            }
            return;
          }
          this.$message.error((res && res.message) || "上传失败");
          if (options && typeof options.onError === "function") {
            options.onError(new Error((res && res.message) || "上传失败"));
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "上传失败");
          if (options && typeof options.onError === "function") {
            options.onError(err);
          }
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    clearColorImage(index) {
      this.$set(this.editColorList[index], "imageUrl", "");
    },
    openQualityDialog(row) {
      this.currentRow = row;
      this.editQualityStandards = this.getQualityStandards(row).map(item => ({
        content: this.limitQualityContent(item.content || ""),
        imageUrls: Array.isArray(item.imageUrls) ? item.imageUrls.slice() : [],
      }));
      if (!this.editQualityStandards.length) {
        this.editQualityStandards.push({ content: "", imageUrls: [] });
      }
      this.activeQualityIndex = 0;
      this.qualityDialogVisible = true;
    },
    openQualityRemarkDialog(row) {
      this.currentRow = row;
      this.editQualityRemark = row.qualityRemark || "";
      this.qualityRemarkDialogVisible = true;
    },
    saveQualityRemark() {
      if (!this.currentRow || !this.currentRow.materialId) {
        this.$message.error("缺少材料信息");
        return;
      }
      const payload = {
        materialId: this.currentRow.materialId,
        materialName: this.currentRow.materialName,
        qualityRemark: (this.editQualityRemark || "").trim(),
      };
      this.savingQualityRemark = true;
      requestModules
        .addOrUpdateMaterial(payload)
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || res.msg || "保存失败");
            return;
          }
          this.$message.success("质检备注已保存");
          this.qualityRemarkDialogVisible = false;
          this.fetchList();
        })
        .catch(err => {
          this.$message.error((err && err.message) || "保存失败");
        })
        .finally(() => {
          this.savingQualityRemark = false;
        });
    },
    limitQualityContent(text) {
      const value = text == null ? "" : String(text);
      return value.length > 200 ? value.slice(0, 200) : value;
    },
    setActiveQualityIndex(index) {
      this.activeQualityIndex = index;
    },
    onQualityDialogOpened() {
      document.addEventListener("paste", this.handleQualityPaste);
      this.$nextTick(() => {
        if (this.$refs.qualityPastePanel) {
          this.$refs.qualityPastePanel.focus();
        }
      });
    },
    onQualityDialogClosed() {
      document.removeEventListener("paste", this.handleQualityPaste);
      this.uploading = false;
      this.activeQualityIndex = 0;
    },
    handleQualityPaste(event) {
      if (!this.qualityDialogVisible || this.uploading) {
        return;
      }
      const items = event.clipboardData && event.clipboardData.items;
      if (!items || !items.length) {
        return;
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === "file" && item.type.indexOf("image/") === 0) {
          event.preventDefault();
          const file = item.getAsFile();
          if (file) {
            this.uploadQualityImageFile(file, this.resolveActiveQualityIndex());
          }
          return;
        }
      }
    },
    resolveActiveQualityIndex() {
      if (!this.editQualityStandards.length) {
        return -1;
      }
      if (this.activeQualityIndex >= 0 && this.activeQualityIndex < this.editQualityStandards.length) {
        return this.activeQualityIndex;
      }
      return this.editQualityStandards.length - 1;
    },
    uploadQualityImageFile(file, standardIndex) {
      if (standardIndex < 0) {
        this.$message.error("请先添加质检标准");
        return;
      }
      if (!this.isImageFile(file)) {
        this.$message.error("请粘贴图片文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("bizModule", "materialQuality");
      this.uploading = true;
      ossModules
        .upload(formData)
        .then(res => {
          if (res && res.objData && res.objData.fileUrl) {
            const standard = this.editQualityStandards[standardIndex];
            if (!standard.imageUrls) {
              this.$set(standard, "imageUrls", []);
            }
            standard.imageUrls.push(res.objData.fileUrl);
            return;
          }
          this.$message.error((res && res.message) || "上传失败");
        })
        .catch(err => {
          this.$message.error((err && err.message) || "上传失败");
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    addQualityStandard() {
      this.editQualityStandards.push({ content: "", imageUrls: [] });
      this.activeQualityIndex = this.editQualityStandards.length - 1;
    },
    removeQualityStandard(index) {
      this.editQualityStandards.splice(index, 1);
      if (this.activeQualityIndex >= this.editQualityStandards.length) {
        this.activeQualityIndex = Math.max(this.editQualityStandards.length - 1, 0);
      }
    },
    removeQualityImage(standardIndex, imageIndex) {
      const standard = this.editQualityStandards[standardIndex];
      if (!standard || !standard.imageUrls) {
        return;
      }
      standard.imageUrls.splice(imageIndex, 1);
    },
    customQualityUpload(options, standardIndex) {
      this.setActiveQualityIndex(standardIndex);
      const file = options && options.file;
      if (!this.isImageFile(file)) {
        this.$message.error("请上传图片文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("bizModule", "materialQuality");
      this.uploading = true;
      ossModules
        .upload(formData)
        .then(res => {
          if (res && res.objData && res.objData.fileUrl) {
            const standard = this.editQualityStandards[standardIndex];
            if (!standard.imageUrls) {
              this.$set(standard, "imageUrls", []);
            }
            standard.imageUrls.push(res.objData.fileUrl);
            if (options && typeof options.onSuccess === "function") {
              options.onSuccess(res);
            }
            return;
          }
          this.$message.error((res && res.message) || "上传失败");
          if (options && typeof options.onError === "function") {
            options.onError(new Error((res && res.message) || "上传失败"));
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "上传失败");
          if (options && typeof options.onError === "function") {
            options.onError(err);
          }
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    saveQualityStandards() {
      if (!this.currentRow || !this.currentRow.materialId) {
        this.$message.error("缺少材料信息");
        return;
      }
      const invalid = this.editQualityStandards.find(item => (item.content || "").length > 200);
      if (invalid) {
        this.$message.error("质检标准文案不能超过200字");
        return;
      }
      const standards = this.editQualityStandards
        .map(item => ({
          content: this.limitQualityContent((item.content || "").trim()),
          imageUrls: Array.isArray(item.imageUrls) ? item.imageUrls.filter(Boolean) : [],
        }))
        .filter(item => item.content || item.imageUrls.length);
      const payload = {
        materialId: this.currentRow.materialId,
        materialName: this.currentRow.materialName,
        qualityStandards: JSON.stringify(standards),
      };
      this.savingQuality = true;
      requestModules
        .addOrUpdateMaterial(payload)
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || res.msg || "保存失败");
            return;
          }
          this.$message.success("质检标准已保存");
          this.qualityDialogVisible = false;
          this.fetchList();
        })
        .catch(err => {
          this.$message.error((err && err.message) || "保存失败");
        })
        .finally(() => {
          this.savingQuality = false;
        });
    },
    saveColorImages() {
      if (!this.currentRow || !this.currentRow.materialId) {
        this.$message.error("缺少材料信息");
        return;
      }
      const payload = {
        materialId: this.currentRow.materialId,
        materialName: this.currentRow.materialName,
        purcharseColorList: JSON.stringify(
          this.editColorList.map(item => ({
            color: item.color,
            purcharseColorName: item.purcharseColorName || "",
            imageUrl: item.imageUrl || "",
          }))
        ),
      };
      this.saving = true;
      requestModules
        .addOrUpdateMaterial(payload)
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || res.msg || "保存失败");
            return;
          }
          this.$message.success("保存成功");
          this.uploadDialogVisible = false;
          this.fetchList();
        })
        .catch(err => {
          this.$message.error((err && err.message) || "保存失败");
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

.product-quality-mgmt-page {
  .breadcrumb-box {
    flex-shrink: 0;
    margin-bottom: 12px;
    padding: 12px 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    border: 1px solid #ebeef5;

    .el-breadcrumb {
      line-height: 1;
      font-size: 13px;
    }
  }

  .filter-input-material-id {
    width: 140px;
  }

  .text-muted {
    color: #c0c4cc;
  }

  .color-thumb-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 12px;
    padding: 4px 0;
  }

  .color-thumb-item {
    width: 64px;
    text-align: center;
  }

  .color-thumb-image,
  .color-thumb-placeholder {
    width: 48px;
    height: 48px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    margin: 0 auto;
    overflow: hidden;
    background: #f5f7fa;
  }

  .color-thumb-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #c0c4cc;
    font-size: 18px;
  }

  .color-thumb-name {
    margin-top: 4px;
    font-size: 12px;
    color: #606266;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .qc-standard-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 4px 0;
  }

  .qc-standard-item {
    padding-bottom: 6px;
    border-bottom: 1px dashed #ebeef5;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .qc-standard-content {
    font-size: 12px;
    color: #303133;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .qc-standard-thumbs {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 6px;
  }

  .qc-standard-thumb {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }
}

.material-quality-upload-dialog {
  .upload-panel {
    outline: none;
  }

  .upload-toolbar {
    margin-bottom: 10px;
    padding: 8px 10px;
    border-radius: 6px;
    background: #f4f4f5;
  }

  .upload-toolbar-tip {
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
  }

  .upload-empty {
    color: #909399;
    padding: 24px 0;
    text-align: center;
  }

  .upload-color-list {
    max-height: 420px;
    overflow: auto;
  }

  .upload-color-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px;
    margin-bottom: 8px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    background: #fff;
    cursor: pointer;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:last-child {
      margin-bottom: 0;
    }

    &.is-active {
      border-color: #409eff;
      box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.12);
    }
  }

  .upload-color-title-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .upload-color-title {
    font-size: 14px;
    color: #303133;
    font-weight: 500;
  }

  .upload-color-sub {
    margin-top: 4px;
    font-size: 12px;
    color: #909399;
  }

  .upload-color-media {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
  }

  .upload-preview-wrap {
    position: relative;
    width: 64px;
    height: 64px;
  }

  .upload-preview-image {
    width: 64px;
    height: 64px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }

  .upload-preview-clear {
    position: absolute;
    top: -8px;
    right: -8px;
    font-size: 16px;
    color: #f56c6c;
    cursor: pointer;
    background: #fff;
    border-radius: 50%;
  }

  .upload-add .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    background: #fafafa;
  }

  .upload-trigger {
    width: 64px;
    height: 64px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #909399;
    font-size: 12px;
    gap: 4px;

    i {
      font-size: 18px;
    }
  }

  .upload-tip {
    margin-top: 12px;
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
  }
}

.material-quality-standard-dialog {
  .el-dialog__body {
    padding: 12px 20px 16px;
    background: #f5f7fa;
  }

  .el-dialog__footer {
    padding: 12px 20px 16px;
    border-top: 1px solid #ebeef5;
  }

  .qc-edit-panel {
    outline: none;
  }

  .qc-edit-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
    padding: 10px 12px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
  }

  .qc-edit-toolbar-left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    min-width: 0;
  }

  .qc-edit-count {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
  }

  .qc-edit-toolbar-tip {
    font-size: 12px;
    color: #909399;
  }

  .qc-edit-list {
    max-height: 520px;
    overflow: auto;
    padding-right: 2px;
  }

  .qc-edit-card {
    position: relative;
    margin-bottom: 12px;
    padding: 14px 16px 16px;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 10px;
      bottom: 10px;
      width: 3px;
      border-radius: 0 2px 2px 0;
      background: transparent;
      transition: background 0.15s ease;
    }

    &:hover {
      border-color: #d9ecff;
    }

    &.is-active {
      border-color: #409eff;
      box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.12);

      &::before {
        background: #409eff;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .qc-edit-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  }

  .qc-edit-card-title-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .qc-edit-index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #ecf5ff;
    color: #409eff;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
  }

  .qc-edit-card-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  .qc-edit-remove {
    color: #f56c6c;
    padding: 0 4px;

    &:hover {
      color: #f78989;
    }
  }

  .qc-edit-field {
    & + & {
      margin-top: 14px;
    }
  }

  .qc-edit-label {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 8px;
    font-size: 13px;
    color: #606266;
    font-weight: 500;

    em {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      color: #909399;
    }
  }

  .qc-edit-images {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 12px;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
    background: #fafbfc;
  }

  .qc-edit-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 180px;
    padding: 24px;
    background: #fff;
    border: 1px dashed #dcdfe6;
    border-radius: 8px;
    color: #909399;

    i {
      font-size: 28px;
      color: #c0c4cc;
    }

    p {
      margin: 0 0 4px;
      font-size: 13px;
    }
  }

  .upload-preview-wrap {
    position: relative;
    width: 72px;
    height: 72px;
  }

  .upload-preview-image {
    width: 72px;
    height: 72px;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    background: #fff;
  }

  .upload-preview-clear {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: #909399;
    color: #fff;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);

    i {
      font-size: 12px;
    }

    &:hover {
      background: #f56c6c;
    }
  }

  .upload-add .el-upload {
    border: 1px dashed #c0c4cc;
    border-radius: 6px;
    cursor: pointer;
    background: #fff;
    transition: border-color 0.15s ease, color 0.15s ease;

    &:hover {
      border-color: #409eff;
      color: #409eff;
    }
  }

  .upload-trigger {
    width: 72px;
    height: 72px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #909399;
    font-size: 12px;
    gap: 4px;

    i {
      font-size: 18px;
    }
  }

  .upload-add .el-upload:hover .upload-trigger {
    color: #409eff;
  }

  .qc-edit-footer-tip {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin-top: 12px;
    padding: 8px 10px;
    border-radius: 6px;
    background: #f4f4f5;
    color: #909399;
    font-size: 12px;
    line-height: 1.5;

    i {
      margin-top: 2px;
      color: #909399;
    }
  }
}
</style>
